import React, { Component } from 'react';
import _ from 'lodash';
import { Accordion, Header, Icon, Container } from 'semantic-ui-react';

class ESLintSection extends Component
{
    state = { activeIndex : -1 };

    handleClick = ( e, titleProps ) => {
        const { index } = titleProps;
        const { activeIndex } = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState( { activeIndex: newIndex } );
    };


    formatESLintCode( message )
    {
        return `${message.source}\n${_.repeat( ' ', message.column - 1 )}^`;
    }


   render()
    {
        if( _.get( this.props, 'report.data.eslint.messages.length', 0 ) === 0 )
        {
            return null;
        }

        const { activeIndex } = this.state;

        const entries = _.map( this.props.report.data.eslint.messages,
            ( message, index ) => {
                return (
                    <eslint-accordion-message key={index}>
                        <Accordion.Title index={index} active={( activeIndex === index )} onClick={this.handleClick}>
                            <Header
                                size={`small`}
                            >
                                <Header.Content><Icon name={'dropdown'} /> {message.message}</Header.Content>
                                <Header.Subheader>{`${message.file}:${message.line}`}</Header.Subheader>
                            </Header>

                        </Accordion.Title>
                        <Accordion.Content active={( activeIndex === index )}>
                            <code><pre>{this.formatESLintCode( message )}</pre></code>
                        </Accordion.Content>
                    </eslint-accordion-message>
                );
            }
        );

        return (
            <Container className='ESLint'>
                <Header size={`large`}>ESLint Issues</Header>
                <Accordion fluid>
                    {entries}
                </Accordion>
            </Container>
        );
    }
}

export default ESLintSection;




// WEBPACK FOOTER //
// ./src/lib/components/PackageView/Sections/ESLint.js